import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Story } from "./components/sections/Story";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { OfferStack } from "./components/sections/OfferStack";
import { Guarantee } from "./components/sections/Guarantee";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { DoctorMessage } from "./components/sections/DoctorMessage";
import { Testimonials } from "./components/sections/Testimonials";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-cream" data-id="element-0" data-mp="3ij65gd4jrr9g">
      <MetaPixel data-id="element-1" data-mp="3mlawd43m29se" />
      <Hero data-id="element-2" data-mp="3mkrd9k285fcs" />
      <main data-id="element-3" data-mp="3mkhmvvd9p66k">
        <Story data-id="element-4" data-mp="3mjzsz5e2v41t" />
        <PainPoints data-id="element-5" data-mp="3mjpyb4i388ps" />
        <Volumes data-id="element-6" data-mp="3rc9f0ac2njyt" />
        <Tools data-id="element-7" data-mp="3rbr9so7flver" />
        <Bonuses data-id="element-8" data-mp="3rbzpsoyupgu6" />
        <OfferStack data-id="element-9" data-mp="3rdkkqfp2v1sk" />
        <Guarantee data-id="element-10" data-mp="3recdzjv7cnfo" />
        <BeforeAfter data-id="element-11" data-mp="5yimri0b7dt" />
        <DoctorMessage data-id="element-12" data-mp="6htxpd5ixiv" />
        <Testimonials data-id="element-13" data-mp="4n5w26l2pak" />
        <Faq data-id="element-14" data-mp="56qxrrj5tst" />
        <FinalCta data-id="element-15" data-mp="7st1bvnjh3n" />
      </main>
      <Footer data-id="element-16" data-mp="2zlli5ahfl0qy" />
      <FloatingCta data-id="element-17" data-mp="2zm4wyibsb90r" />
      <PurchasePopup data-id="element-18" data-mp="2zmo5x9jgin2n" />
    </div>;
}